import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { SiteFeatureConfigSymbol, ServiceProvider, PlatformConfig } from '@wix/thunderbolt-symbols'
import {
	UrlDefinition as definition,
	IUrlService,
	IUrlServiceConfig,
	IUrlDefinition,
} from '@wix/viewer-service-url/definition'
import { UrlService as impl } from '@wix/viewer-service-url/implementations'
import type { ServiceFactoryOpts } from '@wix/services-manager/types'
import { name } from './symbols'

export const urlService = withDependencies(
	[named(SiteFeatureConfigSymbol, name)],
	(
		siteFeatureConfig: IUrlServiceConfig
	): ServiceProvider<IUrlDefinition, (opts: ServiceFactoryOpts<IUrlServiceConfig>) => IUrlService> => {
		return {
			definition,
			impl,
			config: siteFeatureConfig,
			platformConfig: (siteFeatureConfig as any) as PlatformConfig,
		}
	}
)

export { definition, impl }
